import React from 'react';
import { HIGHLIGHT_PHRASES, SOURCE_ID, samplePosting } from '../../data/demo';
interface Props {
  activePhrases: number;
  representative?: boolean;
}

// Splits each paragraph on the tracked phrases so they can be underlined in sequence.
function renderParagraph(text: string, activePhrases: number, key: number) {
  const pattern = new RegExp(`(${HIGHLIGHT_PHRASES.join('|')})`, 'g');
  const parts = text.split(pattern);
  return <p key={key} className="mb-3.5 text-[13px] leading-relaxed text-ink/85 last:mb-0" data-id="element-81" data-mp="2qluv88938pma">
      {parts.map((part, i) => {
      const phraseIndex = HIGHLIGHT_PHRASES.indexOf(part);
      if (phraseIndex === -1) return <React.Fragment key={i} data-id="element-82" data-mp="2gmxbrjqirma5">{part}</React.Fragment>;
      const on = phraseIndex < activePhrases;
      return <span key={i} className={`phrase ${on ? 'phrase-on' : ''}`} data-id="element-83" data-mp="2lo30l6h26pee" data-mpi={i}>
            {part}
          </span>;
    })}
    </p>;
}
export function SourceCard({
  activePhrases,
  representative = false
}: Props) {
  return <article className="rounded-sm bg-white ring-1 ring-rule" data-id="element-84" data-mp="1qrf1qooknblr">
      <header className="border-b border-rule px-6 py-5" data-id="element-85" data-mp="1qtrt1sg7yybh">
        <p className="eyebrow text-muted" data-id="element-86" data-mp="1mroeuw261fmi">
          {representative ? 'Representative posting · Financial Controller' : 'Job posting'}
        </p>
        <h2 className="mt-2 text-[15px] font-semibold leading-snug text-ink" data-id="element-87" data-mp="1vr1e6vwksnti">
          {samplePosting.title}
        </h2>
        <p className="mt-1.5 text-[12px] text-muted" data-id="element-88" data-mp="29qastr54v9vd">{samplePosting.meta}</p>
      </header>
      <div className="px-6 py-5" data-id="element-89" data-mp="25ph44vjv9r1f">
        {samplePosting.paragraphs.map((p, i) => renderParagraph(p, activePhrases, i))}
      </div>
      <footer className="border-t border-rule px-6 py-3 font-mono-num text-[11px] text-muted/80" data-id="element-90" data-mp="2jfauxjexmlds">
        {SOURCE_ID} · {representative ? 'library sample for this role' : 'rendered from source'}
      </footer>
    </article>;
}